import { DateTime } from "luxon";

export function getTimeFromDateTimeIso(dateTimeIso: string) {
    return dateTimeIso ? DateTime.fromISO(dateTimeIso).toFormat("HH:mm") : "Invalid date";
}
